"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureStartedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AdventureStartedEventArgs {
    constructor() {
        this.__type = EventType_1.EventType.AdventureStarted;
        this.__typeName = "AdventureStarted";
    }
}
exports.AdventureStartedEventArgs = AdventureStartedEventArgs;
